import React, {Component, useEffect} from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import * as actions from '../../store/actions/index';
import { withStyles } from '@material-ui/core/styles';

import Iframe from 'react-iframe'

const styles = {
 
    card2: {
        alignItems:'center',
        align: 'center',
        boxShadow: 'none',
        border:'none',
        // height:'100%',
        // width:'100vw',
        // minHeight: 700,
        // minWidth: 725,
        marginLeft:'auto',
        marginRight: 'auto'
    },
    myClassname:{

    }
  };

class ChatBox extends Component {

    state={
        height:'30vh',
        width:'30vw',
        uniqueId: localStorage.getItem('token'),
        showBotAmend: true
    }

    componentDidMount(){
        setInterval(()=>{
            this.setState({
                height:'100vh',
                width:'100vw'
            })
        },3000)

        var userType = ''
        if(this.props.claimantUniqueId == this.state.uniqueId){
            userType='claimant'
        }else if(this.props.respondentUniqueId == this.state.uniqueId){
            userType='respondent'
        }

        var urll = (''+window.location).includes('onBoarding')
        console.log('WL: '+urll +' '+(''+urll).includes('onBoarding'))
        if (userType == 'respondent' && urll){
            this.setState({
                showBotAmend:false
            })
        }
        // setTimeout(()=>{
            // var check = document.getElementById("myId").contentWindow.param1;
            // console.log('parent check param1: '+check)
        // },4000)
        
    }

    switchReEnterData= () => {

        if(this.props.claimantUniqueId == this.state.uniqueId){
            this.setState({
                userType:'claimant'
            })
        }else if(this.props.respondentUniqueId == this.state.uniqueId){
            this.setState({
                userType:'respondent'
            })
        }

        if (this.state.userType == 'claimant'){
            console.log('claimant setting')
            // this.setState({
            //     reEnterData: (!this.state.reEnterData)
            // })
            localStorage.removeItem('token');
            localStorage.removeItem('tokenExpirationDate');
            localStorage.removeItem('caseId');
            window.open('https://www.hkarbsoc.org.hk/odr','_blank');
            // setTimeout(()=>{
            //     window.open('/odr/#/redenterdata/')
            // },1000)
           
        }
        else if (this.state.userType == 'respondent'){
            console.log('respondent setting')
            this.props.changeResponseToReEnter(this.props.caseId)
        }
    }

    render(){
        
        console.log('ChatBox this.props.caseId: '+this.props.caseId)
        let fileURL = __dirname + 'chatbot_response.html?caseId='+this.props.caseId

        return(
            <div style={{height:this.state.height, width:this.state.width}}>
                {this.state.showBotAmend && <Button
                    variant="contained"
                    type="submit"
                    color="primary"
                    style={{textAlign: 'center'}}
                    // className={classes.button}
                    onClick={this.switchReEnterData}
                >
                    {(!this.state.reEnterData) && this.context.t('Amend')}
                    {(this.state.reEnterData) && this.context.t('Read PDF')}
                </Button> }
                <Iframe url={fileURL}
                    position="relative"
                    // width="60%"
                    // height="100%"
                    // height="100%"
                    id="myId"
                    className="myClassname"
                    />
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
    isAuthenticated: state.auth.token !== null,
    //userId: state.auth.userId,
    caseId: state.caseInfo.caseId,
    claimantUniqueId: state.caseInfo.claimantUniqueId,
    respondentUniqueId: state.caseInfo.respondentUniqueId,
    claimant_name: state.caseInfo.claimant_name,
    respondent_name: state.caseInfo.respondent_name,
    userType: state.caseInfo.userType,
    conversationId: state.caseInfo.conversationId,
    caseId: state.caseInfo.caseId,
    userType: state.caseInfo.userType,
    loadingCaseInfo: state.caseInfo.loading,
    loadingStepCompleted: state.onBoarding.loading,
    caseData: state.caseInfo.caseData,
    steps_completed: state.caseInfo[`${state.caseInfo.userType}_steps_completed`],
    newAccount:  state.caseInfo[`${state.caseInfo.userType}_newAccount`] ? state.caseInfo[`${state.caseInfo.userType}_newAccount`]/*['newAccount']*/ : null,
    }
  }
  
  const mapDispatchToProps = (dispatch) => {
    return {
      onLogout: () => dispatch(actions.logout()),
      onAuth: (username, password) => dispatch(actions.auth(username, password)),
      onBoardingStepCompletion: (uniqueId, caseId, userType, step_completed) => dispatch(actions.onBoardingStepCompletion(uniqueId, caseId, userType, step_completed)),
      getCaseInfo: (caseId, uniqueId) => dispatch(actions.getCaseInfo(caseId, uniqueId)),
      getUserInformation: (uniqueId) => dispatch(actions.getUserInformation(uniqueId)),
      changeResponseToReEnter: (caseId) => dispatch(actions.changeResponseToReEnter(caseId)),
    }
  }

ChatBox.contextTypes = {
    t: PropTypes.func
}

// export default withStyles(styles)(ChatBox);
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(withRouter(ChatBox)));